import { cva } from 'class-variance-authority';

export const BADGE_VARIANTS = cva(
  'inline-flex w-fit shrink-0 items-center justify-center font-semibold whitespace-nowrap tabular-nums leading-none select-none transition-[color,background-color,border-color,box-shadow] overflow-hidden [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive font-semibold',
  {
    variants: {
      size: {
        sm: 'h-6 min-w-6 text-body-xs px-2',
        default: 'h-8 min-w-8 text-body-sm px-3',
        md: 'h-10 min-w-10 text-body-sm px-3',
      },
      borderRadius: {
        rounded: 'rounded-lg',
        soft: 'rounded-xxs',
      },
      variant: {
        primary: '',
        red: '',
        orange: '',
        yellow: '',
        lime: '',
        green: '',
        teal: '',
        cyan: '',
        blue: '',
        indigo: '',
        violet: '',
        grape: '',
        pink: '',
        transparent: '',
        'neutral-0': '',
        'neutral-1': '',
        'neutral-2': '',
        'neutral-3': '',
        'neutral-4': '',
        'neutral-5': '',
        'neutral-6': '',
        'neutral-7': '',
        'neutral-8': '',
        'neutral-9': '',
        'neutral-10': '',
      },
      border: {
        true: '',
        false: '',
      },
      mode: {
        normal: '',
        light: '',
      },
    },
    compoundVariants: [
      {
        mode: 'light',
        variant: 'primary',
        className: 'bg-primary-lightest text-primary-base',
      },
      {
        mode: 'light',
        variant: 'red',
        className: 'bg-red-lightest text-red-darker',
      },
      {
        mode: 'light',
        variant: 'orange',
        className: 'bg-orange-lightest text-orange-darker',
      },
      {
        mode: 'light',
        variant: 'yellow',
        className: 'bg-yellow-lightest text-yellow-darker',
      },
      {
        mode: 'light',
        variant: 'lime',
        className: 'bg-lime-lightest text-lime-darker',
      },
      {
        mode: 'light',
        variant: 'green',
        className: 'bg-green-lightest text-green-darker',
      },
      {
        mode: 'light',
        variant: 'teal',
        className: 'bg-teal-lightest text-teal-darker',
      },
      {
        mode: 'light',
        variant: 'cyan',
        className: 'bg-cyan-lightest text-cyan-darker',
      },
      {
        mode: 'light',
        variant: 'blue',
        className: 'bg-blue-lightest text-blue-darker',
      },
      {
        mode: 'light',
        variant: 'indigo',
        className: 'bg-indigo-lightest text-indigo-darker',
      },
      {
        mode: 'light',
        variant: 'violet',
        className: 'bg-violet-lightest text-violet-darker',
      },
      {
        mode: 'light',
        variant: 'grape',
        className: 'bg-grape-lightest text-grape-darker',
      },
      {
        mode: 'light',
        variant: 'pink',
        className: 'bg-pink-lightest text-pink-darker',
      },
      {
        mode: 'normal',
        variant: 'neutral-0',
        className: 'bg-neutral-0 text-primary-base',
      },
      {
        mode: 'light',
        variant: 'neutral-1',
        className: 'bg-neutral-1 text-neutral-9',
      },
      {
        mode: 'light',
        variant: 'neutral-2',
        className: 'bg-neutral-2 text-neutral-9',
      },
      {
        mode: 'light',
        variant: 'neutral-3',
        className: 'bg-neutral-3 text-neutral-9',
      },
      {
        mode: 'light',
        variant: 'neutral-4',
        className: 'bg-neutral-4 text-neutral-9',
      },
      {
        mode: 'light',
        variant: 'neutral-5',
        className: 'bg-neutral-5 text-neutral-0',
      },
      {
        mode: 'light',
        variant: 'neutral-6',
        className: 'bg-neutral-6 text-neutral-0',
      },
      {
        mode: 'light',
        variant: 'neutral-7',
        className: 'bg-neutral-7 text-neutral-0',
      },
      {
        mode: 'light',
        variant: 'neutral-8',
        className: 'bg-neutral-8 text-neutral-0',
      },
      {
        mode: 'light',
        variant: 'neutral-9',
        className: 'bg-neutral-9 text-neutral-0',
      },
      {
        mode: 'light',
        variant: 'neutral-10',
        className: 'bg-neutral-10 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'transparent',
        className: 'bg-transparent text-primary-base !border !border-primary-base',
      },
      {
        mode: 'normal',
        variant: 'neutral-0',
        className: 'bg-neutral-0 text-primary-base',
      },
      {
        mode: 'normal',
        variant: 'neutral-1',
        className: 'bg-neutral-1 text-neutral-9',
      },
      {
        mode: 'normal',
        variant: 'neutral-2',
        className: 'bg-neutral-2 text-neutral-9',
      },
      {
        mode: 'normal',
        variant: 'neutral-3',
        className: 'bg-neutral-3 text-neutral-9',
      },
      {
        mode: 'normal',
        variant: 'neutral-4',
        className: 'bg-neutral-4 text-neutral-9',
      },
      {
        mode: 'normal',
        variant: 'neutral-5',
        className: 'bg-neutral-5 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'neutral-6',
        className: 'bg-neutral-6 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'neutral-7',
        className: 'bg-neutral-7 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'neutral-8',
        className: 'bg-neutral-8 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'neutral-9',
        className: 'bg-neutral-9 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'neutral-10',
        className: 'bg-neutral-10 text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'primary',
        className: 'bg-primary-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'red',
        className: 'bg-red-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'orange',
        className: 'bg-orange-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'yellow',
        className: 'bg-yellow-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'lime',
        className: 'bg-lime-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'green',
        className: 'bg-green-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'teal',
        className: 'bg-teal-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'cyan',
        className: 'bg-cyan-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'blue',
        className: 'bg-blue-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'indigo',
        className: 'bg-indigo-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'violet',
        className: 'bg-violet-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'grape',
        className: 'bg-grape-base text-neutral-0',
      },
      {
        mode: 'normal',
        variant: 'pink',
        className: 'bg-pink-base text-neutral-0',
      },
      // Border compound variants
      {
        border: true,
        variant: 'neutral-3',
        className: 'border border-neutral-5',
      },
      {
        border: true,
        variant: 'neutral-4',
        className: 'border border-neutral-5',
      },
      {
        border: true,
        variant: 'primary',
        className: 'border border-primary-lighter',
      },
      {
        border: true,
        variant: 'red',
        className: 'border border-red-lighter',
      },
      {
        border: true,
        variant: 'orange',
        className: 'border border-orange-lighter',
      },
      {
        border: true,
        variant: 'yellow',
        className: 'border border-yellow-lighter',
      },
      {
        border: true,
        variant: 'lime',
        className: 'border border-lime-lighter',
      },
      {
        border: true,
        variant: 'green',
        className: 'border border-green-lighter',
      },
      {
        border: true,
        variant: 'teal',
        className: 'border border-teal-lighter',
      },
      {
        border: true,
        variant: 'cyan',
        className: 'border border-cyan-lighter',
      },
      {
        border: true,
        variant: 'blue',
        className: 'border border-blue-lighter',
      },
      {
        border: true,
        variant: 'indigo',
        className: 'border border-indigo-lighter',
      },
      {
        border: true,
        variant: 'violet',
        className: 'border border-violet-lighter',
      },
      {
        border: true,
        variant: 'grape',
        className: 'border border-grape-lighter',
      },
      {
        border: true,
        variant: 'pink',
        className: 'border border-pink-lighter',
      },
    ],
    defaultVariants: {
      size: 'default',
      borderRadius: 'rounded',
      variant: 'primary',
      border: false,
    },
  },
);
